import React, { useState, useEffect, useCallback } from 'react';
import Icon from './Icon';
import { toast } from './ToastProvider';
import { apiFetch } from '../config/api';
import '../styles/B2BTrainings.css';

const CATALOGUE_MALE = [
  { id:'m1',  name:'Szampon dla mężczyzn 3w1',        unit:'szt', price:35,  category:'Pielęgnacja', desc:'Włosy, broda i ciało' },
  { id:'m2',  name:'Odżywka do brody Premium',         unit:'szt', price:45,  category:'Pielęgnacja', desc:'Nawilżenie i zmiękczenie' },
  { id:'m3',  name:'Olejek do brody',                  unit:'szt', price:55,  category:'Pielęgnacja', desc:'Naturalne olejki arganowe' },
  { id:'m4',  name:'Wosk modelujący extra hold',       unit:'szt', price:38,  category:'Stylizacja',  desc:'Mocne utrwalenie, matowe wykończenie' },
  { id:'m5',  name:'Pomada barberska błyszcząca',      unit:'szt', price:42,  category:'Stylizacja',  desc:'Klasyczny look, mocne utrwalenie' },
  { id:'m6',  name:'Pasta matująca do włosów',         unit:'szt', price:40,  category:'Stylizacja',  desc:'Tekstura i mat, średnie utrwalenie' },
  { id:'m7',  name:'Krem do golenia profesjonalny',    unit:'szt', price:35,  category:'Golenie',     desc:'Nawilżający, do skóry wrażliwej' },
  { id:'m8',  name:'Balsam po goleniu',                unit:'szt', price:40,  category:'Golenie',     desc:'Kojący, bez alkoholu' },
  { id:'m9',  name:'Żel do golenia brzytwą',           unit:'szt', price:30,  category:'Golenie',     desc:'Przezroczysty, precyzyjne golenie' },
  { id:'m10', name:'Rękawiczki jednorazowe (100szt)',  unit:'op',  price:35,  category:'Akcesoria',   desc:'Nitryl, bezpudrowe' },
  { id:'m11', name:'Ręczniki fryzjerskie (10szt)',     unit:'op',  price:60,  category:'Akcesoria',   desc:'100% bawełna, 50x90cm' },
  { id:'m12', name:'Peleryna barberska',               unit:'szt', price:45,  category:'Akcesoria',   desc:'Wodoodporna, regulowana' },
  { id:'m13', name:'Maszynka do strzyżenia HairPro X3',unit:'szt', price:320, category:'Sprzęt',      desc:'5 nasadek, akumulator 3h' },
  { id:'m14', name:'Trymer do brody profesjonalny',    unit:'szt', price:280, category:'Sprzęt',      desc:'Precyzyjne wykończenia' },
  { id:'m15', name:'Brzytwa fryzjerska',               unit:'szt', price:150, category:'Sprzęt',      desc:'Stal nierdzewna, wymienne ostrza' },
];

const CATALOGUE_FEMALE = [
  { id:'f1',  name:'Szampon nawilżający do włosów suchych', unit:'szt', price:55,  category:'Pielęgnacja', desc:'Keratyna + proteiny jedwabiu' },
  { id:'f2',  name:'Szampon do włosów farbowanych',         unit:'szt', price:58,  category:'Pielęgnacja', desc:'Ochrona koloru, bez siarczanów' },
  { id:'f3',  name:'Odżywka regenerująca Premium',          unit:'szt', price:65,  category:'Pielęgnacja', desc:'Intensywna regeneracja 250ml' },
  { id:'f4',  name:'Maska do włosów zniszczonych',          unit:'szt', price:75,  category:'Pielęgnacja', desc:'Odbudowa struktury włosa' },
  { id:'f5',  name:'Serum termoochronne',                   unit:'szt', price:65,  category:'Stylizacja',  desc:'Ochrona do 230°C' },
  { id:'f6',  name:'Lakier do włosów mocny',                unit:'szt', price:29,  category:'Stylizacja',  desc:'Elastyczne utrwalenie 300ml' },
  { id:'f7',  name:'Pianka do stylizacji',                  unit:'szt', price:32,  category:'Stylizacja',  desc:'Objętość i utrwalenie' },
  { id:'f8',  name:'Farba do włosów (komplet 60ml)',        unit:'op',  price:22,  category:'Koloryzacja', desc:'60 odcieni w palecie' },
  { id:'f9',  name:'Utleniacz 3% 1000ml',                   unit:'szt', price:18,  category:'Koloryzacja', desc:'Do delikatnych rozjaśnień' },
  { id:'f10', name:'Utleniacz 6% 1000ml',                   unit:'szt', price:18,  category:'Koloryzacja', desc:'Standardowa koloryzacja' },
  { id:'f11', name:'Rozjaśniacz do włosów',                 unit:'op',  price:35,  category:'Koloryzacja', desc:'Do baleyage i pasemek' },
  { id:'f12', name:'Rękawiczki jednorazowe (100szt)',        unit:'op',  price:35,  category:'Akcesoria',   desc:'Nitryl, bezpudrowe' },
  { id:'f13', name:'Folia aluminiowa 100m',                 unit:'rol', price:25,  category:'Akcesoria',   desc:'Do pasemek i melirowań' },
  { id:'f14', name:'Suszarka profesjonalna 2400W',          unit:'szt', price:480, category:'Sprzęt',      desc:'Jonizacja, 6 poziomów' },
  { id:'f15', name:'Prostownica profesjonalna',             unit:'szt', price:350, category:'Sprzęt',      desc:'Płytki ceramiczne, 230°C' },
];

const CAT_CFG = {
  'Pielęgnacja': { color:'#3b82f6', bg:'#eff6ff', icon:'star' },
  'Stylizacja':  { color:'#8b5cf6', bg:'#f5f3ff', icon:'scissors' },
  'Koloryzacja': { color:'#ec4899', bg:'#fdf2f8', icon:'edit' },
  'Akcesoria':   { color:'#10b981', bg:'#f0fdf4', icon:'package' },
  'Sprzęt':      { color:'#f59e0b', bg:'#fef3c7', icon:'settings' },
};

const STATUS_CFG = {
  pending:  { bg:'#fef3c7', color:'#92400e', label:'Oczekuje na akceptację', icon:'clock' },
  approved: { bg:'#d1fae5', color:'#065f46', label:'Zaakceptowane',         icon:'confirmed' },
  rejected: { bg:'#fee2e2', color:'#991b1b', label:'Odrzucone',             icon:'rejected' },
};

const B2BPanel = ({ user, approvedSalons }) => {
  const [inventory,     setInventory]     = useState({});
  const [orders,        setOrders]        = useState([]);
  const [cart,          setCart]          = useState({});
  const [selectedSalon, setSelectedSalon] = useState('');
  const [salonCategory, setSalonCategory] = useState('male');
  const [salonCategories, setSalonCategories] = useState({});
  const [tab,           setTab]           = useState('inventory');
  const [expandedOrder, setExpandedOrder] = useState(null);
  const [activeCategory,setActiveCategory]= useState('all');

  const CATALOGUE = salonCategory === 'female' ? CATALOGUE_FEMALE : CATALOGUE_MALE;

  const loadData = useCallback(async () => {
    if (!user?.id) return;
    try {
      const ordersData = await apiFetch('/b2b/orders');
      setOrders(ordersData || []);

      try {
        const allSalons = await apiFetch('/salons');
        const inv = {};

        const salonNames = approvedSalons?.length
          ? approvedSalons.map(s => s.salon_name || s.salonName).filter(Boolean)
          : user.salonName ? [user.salonName] : [];

        const salonCategories = {};
        for (const salonName of salonNames) {
          const salon = allSalons.find(s => s.name === salonName);
          if (salon) {
            salonCategories[salonName] = salon.category || 'male';
            try {
              const invData = await apiFetch(`/b2b/inventory/${salon.id}`);
              (invData || []).forEach(item => {
                if (!inv[salonName]) inv[salonName] = {};
                const itemName = item.name || item.product_name;
                inv[salonName][itemName] = item.stock;
              });
            } catch { }
          }
        }
        setInventory(inv);
        setSalonCategories(salonCategories);
      } catch {}
    } catch (err) {
      console.error('B2B loadData error:', err);
    }
  }, [user?.id, user?.salonName, approvedSalons]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  useEffect(() => {
    if (selectedSalon) return;
    const firstSalon = approvedSalons?.[0];
    const salon = firstSalon?.salon_name || firstSalon?.salonName || user?.salonName || '';
    if (salon) {
      setSelectedSalon(salon);
      setSalonCategory(firstSalon?.category || 'male');
    }
  }, [approvedSalons, user?.salonName, selectedSalon]);

  useEffect(() => {
    if (!selectedSalon) return;
    if (salonCategories[selectedSalon]) {
      setSalonCategory(salonCategories[selectedSalon]);
      return;
    }
    const found = approvedSalons?.find(s => (s.salon_name || s.salonName) === selectedSalon);
    if (found?.category) setSalonCategory(found.category);
  }, [selectedSalon, salonCategories, approvedSalons]);

  useEffect(() => {
    const onFocus = () => loadData();
    window.addEventListener('focus', onFocus);
    window.addEventListener('storage', onFocus);
    return () => {
      window.removeEventListener('focus', onFocus);
      window.removeEventListener('storage', onFocus);
    };
  }, [loadData]);

  const salonInv = inventory[selectedSalon] || {};

  const setQty = (prodId, val) =>
    setCart(c => ({ ...c, [prodId]: Math.max(0, val) }));
  const cartItems = CATALOGUE.filter(p => (cart[p.id] || 0) > 0);
  const cartTotal = cartItems.reduce((s, p) => s + cart[p.id] * p.price, 0);
  const cartCount = cartItems.reduce((s, p) => s + cart[p.id], 0);

  const lowStock = (qty) => qty === 0 ? 'zero' : qty <= 3 ? 'low' : 'ok';

  const submitOrder = async () => {
    if (!cartItems.length) { toast.warning('Koszyk jest pusty'); return; }
    if (!selectedSalon)    { toast.error('Wybierz salon');        return; }
    try {
      await apiFetch('/b2b/orders', {
        method: 'POST',
        body: JSON.stringify({
          salonName: selectedSalon,
          items: cartItems.map(p => ({ name: p.name, price: p.price, qty: cart[p.id], subtotal: cart[p.id] * p.price })),
          total: cartTotal,
        }),
      });
      setCart({});
      setTab('history');
      loadData();
      toast.success(`Zamówienie złożone! Łączna wartość: ${cartTotal} zł - czeka na akceptację.`);
    } catch (err) {
      toast.error(err.message || 'Błąd podczas składania zamówienia');
    }
  };

  const categories = ['all', ...new Set(CATALOGUE.map(p => p.category))];
  const filteredCat = activeCategory === 'all'
    ? CATALOGUE
    : CATALOGUE.filter(p => p.category === activeCategory);

  const salonList = approvedSalons?.length
    ? approvedSalons.map(s => ({ ...s, salonName: s.salon_name || s.salonName }))
    : user?.salonName ? [{ salonName: user.salonName }] : [];

  return (
    <div className="b2b-wrapper">
      {/* Nagłówek */}
      <div className="b2b-header">
        <div className="b2b-header-left">
          <div className="b2b-header-icon"><Icon name="package" color="white" size="xl" /></div>
          <div>
            <h2>Panel B2B</h2>
            <p>Zamówienia produktów profesjonalnych dla Twojego salonu</p>
          </div>
        </div>
        {salonList.length > 0 && (
          <select value={selectedSalon} onChange={e => setSelectedSalon(e.target.value)} className="b2b-salon-select">
            {salonList.map(s => <option key={s.salonName} value={s.salonName}>{s.salonName}</option>)}
          </select>
        )}
      </div>

      {/* Zakładki */}
      <div className="b2b-nav">
        <button className={`b2b-nav-btn ${tab==='inventory'?'active':''}`} onClick={() => setTab('inventory')}>
          <Icon name="list" style={{marginRight:'8px'}} />Stan magazynowy
        </button>
        <button className={`b2b-nav-btn ${tab==='order'?'active':''}`} onClick={() => setTab('order')}>
          <Icon name="add" style={{marginRight:'8px'}} />Złóż zamówienie
          {cartCount > 0 && <span className="b2b-cart-count">{cartCount}</span>}
        </button>
        <button className={`b2b-nav-btn ${tab==='history'?'active':''}`} onClick={() => setTab('history')}>
          <Icon name="calendar" style={{marginRight:'8px'}} />Historia ({orders.length})
        </button>
      </div>

      {/* MAGAZYN */}
      {tab === 'inventory' && (
        <div className="b2b-section">
          <div className="b2b-inventory-header">
            <div>
              <h3>Aktualny stan magazynu</h3>
              <p className="b2b-subtitle">{selectedSalon || 'Twój salon'}</p>
            </div>
            <div style={{display:'flex',gap:'10px',alignItems:'center'}}>
              <button className="b2b-refresh-btn" onClick={loadData} title="Odśwież stan">
                <Icon name="refresh" />
              </button>
              <button className="b2b-order-btn" onClick={() => setTab('order')}>
                <Icon name="add" style={{marginRight:'7px'}} />Złóż zamówienie
              </button>
            </div>
          </div>

          {/* Karty podsumowania */}
          <div className="b2b-inv-summary">
            {['ok','low','zero'].map(lvl => {
              const count = CATALOGUE.filter(p => lowStock(salonInv[p.name]||0) === lvl).length;
              const cfg = { ok:{label:'OK',color:'#10b981',bg:'#d1fae5',icon:'confirmed'}, low:{label:'Niski stan',color:'#f59e0b',bg:'#fef3c7',icon:'warning'}, zero:{label:'Brak',color:'#ef4444',bg:'#fee2e2',icon:'error'} }[lvl];
              return (
                <div key={lvl} className="b2b-inv-card" style={{borderColor: cfg.color+'44', background: cfg.bg}}>
                  <Icon name={cfg.icon} color={cfg.color} size="lg" />
                  <div>
                    <strong style={{color: cfg.color, fontSize:'1.5em'}}>{count}</strong>
                    <span style={{color: cfg.color, fontSize:'0.82em', display:'block'}}>{cfg.label}</span>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="b2b-table-wrap">
            <table className="b2b-table">
              <thead>
                <tr>
                  <th>Produkt</th>
                  <th>Kategoria</th>
                  <th>Stan</th>
                  <th>Wartość</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {CATALOGUE.map(p => {
                  const qty = salonInv[p.name] || 0;
                  const level = lowStock(qty);
                  const cat = CAT_CFG[p.category] || {};
                  return (
                    <tr key={p.id} className={level !== 'ok' ? 'row-warn' : ''}>
                      <td>
                        <div className="b2b-prod-name">
                          <strong>{p.name}</strong>
                          <span className="b2b-prod-desc">{p.desc}</span>
                        </div>
                      </td>
                      <td>
                        <span className="b2b-cat-badge" style={{background:cat.bg, color:cat.color}}>
                          <Icon name={cat.icon} style={{marginRight:'5px',fontSize:'0.8em'}} />{p.category}
                        </span>
                      </td>
                      <td>
                        <div className={`b2b-stock-pill stock-${level}`}>
                          {qty} {p.unit}
                        </div>
                        {level !== 'ok' && (
                          <div className="b2b-stock-warn">
                            {level === 'zero' ? 'Brak w magazynie!' : 'Niski stan - zamów!'}
                          </div>
                        )}
                      </td>
                      <td>
                        <span style={{fontWeight:600, color:'#1e3c72'}}>{(qty * p.price)} zł</span>
                      </td>
                      <td>
                        <button className="b2b-quick-order" onClick={() => { setCart(c => ({...c, [p.id]: (c[p.id]||0)+1})); setTab('order'); }}>
                          <Icon name="add" style={{marginRight:'5px'}} />Zamów
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* ZAMÓWIENIE */}
      {tab === 'order' && (
        <div className="b2b-order-layout">
          {/* Katalog */}
          <div className="b2b-catalogue-col">
            <div className="b2b-cat-filters">
              {categories.map(cat => {
                const cfg = cat === 'all' ? {color:'#1e3c72'} : (CAT_CFG[cat] || {});
                return (
                  <button key={cat}
                    className={`b2b-cat-btn ${activeCategory===cat?'active':''}`}
                    style={activeCategory===cat ? {background: cfg.color, color:'white', borderColor: cfg.color} : {}}
                    onClick={() => setActiveCategory(cat)}>
                    {cat === 'all' ? 'Wszystkie' : cat}
                  </button>
                );
              })}
            </div>

            <div className="b2b-products-grid">
              {filteredCat.map(p => {
                const qty = cart[p.id] || 0;
                const inStock = salonInv[p.name] || 0;
                const cat = CAT_CFG[p.category] || {};
                return (
                  <div key={p.id} className={`b2b-prod-card ${qty > 0 ? 'in-cart' : ''}`}>
                    <div className="b2b-prod-card-cat" style={{background: cat.bg, color: cat.color}}>
                      <Icon name={cat.icon} style={{marginRight:'5px'}} />{p.category}
                    </div>
                    <h4 className="b2b-prod-card-name">{p.name}</h4>
                    <p className="b2b-prod-card-desc">{p.desc}</p>
                    <div className="b2b-prod-card-footer">
                      <div>
                        <span className="b2b-prod-card-price">{p.price} zł/{p.unit}</span>
                        <div className={`b2b-stock-pill stock-${lowStock(inStock)}`} style={{marginTop:'4px',fontSize:'0.78em'}}>
                          Magazyn: {inStock} {p.unit}
                        </div>
                      </div>
                      <div className="b2b-qty-ctrl">
                        <button onClick={() => setQty(p.id, qty - 1)} disabled={qty === 0}>−</button>
                        <input
                          type="number"
                          min="0"
                          value={qty}
                          onChange={e => setQty(p.id, parseInt(e.target.value)||0)}
                          className="b2b-qty-input"
                        />
                        <button onClick={() => setQty(p.id, qty + 1)}>+</button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Podsumowanie koszyka */}
          <div className="b2b-cart-col">
            <div className="b2b-cart-box">
              <h3><Icon name="package" style={{marginRight:'8px'}} />Koszyk zamówienia</h3>
              <p className="b2b-cart-salon">
                <Icon name="salon" style={{marginRight:'6px'}} />{selectedSalon || 'Brak wybranego salonu'}
              </p>
              {cartItems.length === 0 ? (
                <div className="b2b-cart-empty">
                  <Icon name="package" color="#ccc" size="2x" />
                  <p>Koszyk jest pusty</p>
                  <span>Dodaj produkty z katalogu</span>
                </div>
              ) : (
                <>
                  <div className="b2b-cart-items">
                    {cartItems.map(p => (
                      <div key={p.id} className="b2b-cart-row">
                        <div className="b2b-cart-row-info">
                          <strong>{p.name}</strong>
                          <span>{cart[p.id]} × {p.price} zł</span>
                        </div>
                        <div className="b2b-cart-row-total">
                          <strong>{cart[p.id] * p.price} zł</strong>
                          <button onClick={() => setQty(p.id, 0)} className="b2b-remove-btn">
                            <Icon name="close" />
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="b2b-cart-total-row">
                    <span>Razem do zapłaty:</span>
                    <strong>{cartTotal} zł</strong>
                  </div>
                  <div className="b2b-cart-count-row">
                    <Icon name="package" style={{marginRight:'6px'}} />
                    {cartCount} pozycji • {cartItems.length} produktów
                  </div>
                  <button className="b2b-submit-btn" onClick={submitOrder}>
                    <Icon name="send" style={{marginRight:'8px'}} />Złóż zamówienie
                  </button>
                  <button className="b2b-clear-btn" onClick={() => setCart({})}>
                    <Icon name="delete" style={{marginRight:'6px'}} />Wyczyść koszyk
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      )}

      {/* HISTORIA */}
      {tab === 'history' && (
        <div className="b2b-section">
          {orders.length === 0 ? (
            <div className="b2b-empty">
              <Icon name="package" color="#d1d5db" size="3x" />
              <h3>Brak zamówień</h3>
              <p>Złóż pierwsze zamówienie B2B</p>
              <button className="b2b-order-btn" onClick={() => setTab('order')}>
                <Icon name="add" style={{marginRight:'7px'}} />Złóż zamówienie
              </button>
            </div>
          ) : (
            <div className="b2b-orders-list">
              {[...orders].map(order => {
                const sc = STATUS_CFG[order.status] || STATUS_CFG.pending;
                const expanded = expandedOrder === order.id;
                return (
                  <div key={order.id} className="b2b-order-row">
                    <div className="b2b-order-row-head" onClick={() => setExpandedOrder(expanded ? null : order.id)}>
                      <div className="b2b-order-meta">
                        <span className="b2b-order-date">
                          <Icon name="calendar" style={{marginRight:'6px'}} />
                          {new Date(order.created_at || order.createdAt || Date.now()).toLocaleDateString('pl-PL', {day:'numeric',month:'long',year:'numeric'})}
                        </span>
                        <span className="b2b-order-salon">
                          <Icon name="salon" style={{marginRight:'5px'}} />{order.salonName || order.salon_name}
                        </span>
                      </div>
                      <div className="b2b-order-row-right">
                        <strong className="b2b-order-amount">{order.total} zł</strong>
                        <span className="b2b-status-pill" style={{background:sc.bg,color:sc.color}}>
                          <Icon name={sc.icon} style={{marginRight:'5px',fontSize:'0.85em'}} />{sc.label}
                        </span>
                        <Icon name={expanded?'chevron-up':'chevron-down'} color="#999" />
                      </div>
                    </div>
                    {expanded && (
                      <div className="b2b-order-details">
                        <div className="b2b-order-items-grid">
                          {(order.items || []).map((item,i) => (
                            <div key={i} className="b2b-order-item">
                              <span>{item.name}</span>
                              <span className="b2b-order-item-qty">{item.qty} {item.unit}</span>
                              <span className="b2b-order-item-price">{item.subtotal} zł</span>
                            </div>
                          ))}
                        </div>
                        {order.status === 'approved' && (
                          <div className="b2b-approved-note">
                            <Icon name="confirmed" color="#059669" style={{marginRight:'8px'}} />
                            Zamówienie zaakceptowane - produkty zostały dodane do Twojego magazynu.
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default B2BPanel;